import { Card, CardContent, CardHeader } from "@/shared/components/ui/card";
import { Badge } from "@/shared/components/ui/badge";
import { cn } from "@/shared/libs/utils";
import type { DataForwarderPolicy } from "../types/preferences_types";

function ForwardingTypeMark({ type }: { type: "s3" | "gcs" }) {
  if (type === "s3") {
    return (
      <span className="rounded bg-[#FF9900] px-2.5 py-0.5 text-xs font-bold text-white">
        S3
      </span>
    );
  }
  return (
    <span className="rounded bg-[#4285F4] px-2.5 py-0.5 text-xs font-bold text-white">
      GCS
    </span>
  );
}

interface DataForwarderPolicyCardProps {
  policy: DataForwarderPolicy;
  onClick?: (policy: DataForwarderPolicy) => void;
}

export function DataForwarderPolicyCard({ policy, onClick }: DataForwarderPolicyCardProps) {
  const isComplete = policy.register_phase === 3;
  const phaseLabel = isComplete ? "등록 완료" : "등록 진행중";

  return (
    <Card
      className={cn(
        "cursor-pointer border-2 transition-all hover:shadow-md",
        isComplete
          ? "border-green-300 dark:border-green-700"
          : "border-yellow-300 dark:border-yellow-700",
      )}
      onClick={() => onClick?.(policy)}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
        <ForwardingTypeMark type={policy.forwarding_type ?? "s3"} />
        <Badge variant={isComplete ? "success" : "warning"}>{phaseLabel}</Badge>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="truncate text-lg font-semibold">{policy.policy_name}</div>
        <div className="space-y-1.5 text-sm">
          <InfoRow label="ORG ID" value={policy.org_id} />
          <InfoRow label="Workspace ID" value={policy.workspace_id} />
          <InfoRow label="Channel" value={policy.channel} />
        </div>
      </CardContent>
    </Card>
  );
}

function InfoRow({ label, value }: { label: string; value?: string | null }) {
  if (!value) return null;
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="shrink-0 text-muted-foreground">{label}</span>
      <span className="truncate font-medium text-foreground">{value}</span>
    </div>
  );
}
